import ProductManagementApi from 'apis/api/ProductManagement';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import OrderManagerApi from 'apis/api/OrderManager';
import { IProductMixOrder } from 'models/CreateOrder';

import { ICustomer } from 'models/Customer';
import { IOptionData } from 'models/OptionData';
import { IProductMix, IProductSet } from 'models/Production';
import { IProductCategory } from 'models/StockManage/CateProductManage';
import { IProductType } from '@models/StockManage/TypeProductManage';
import { IBrandProduct } from '@models/StockManage/BrandProduct';
import { proccessDetailProductData } from './production.slice';

export const getAllTypeOrders = createAsyncThunk('createOrder/getAllTypeOrders', async () => {
  const response = await OrderManagerApi.GetAllTypeOrders();
  return response.data;
});

export const getInitProductMixData = createAsyncThunk('createOrder/getInitProductMixData', async () => {
  const response = await ProductManagementApi.GetInitProductMix(1, 1000);
  return response.data;
});

export const searchProductMix = createAsyncThunk(
  'createOrder/searchProductMix',
  async (query: { value?: any; typeId?: any; brandId?: any; CateId?: any; allActive?: boolean }) => {
    const response = await ProductManagementApi.SearchProductMix(
      query.value,
      query.typeId || 0,
      query.brandId || 0,
      query.CateId || 0,
      query.allActive == true ? -1 : query.allActive == false ? 0 : 1 // 1 là bán, 0 là k cho bán, -1 là tất cả
    );
    return response.data;
  }
);
// lấy danh sách bộ
export const getAllProductSet = createAsyncThunk('createOrder/getAllProductSet', async () => {
  console.log('goi API ');
  
  const response = await ProductManagementApi.GetSetProductList();
  return response.data;
});
// lấy chi tiết tb trong bộ
export const getDetailProductSet = createAsyncThunk('createOrder/getDetailProductSet', async (id: number) => {
  const response = await ProductManagementApi.GetSetProductById(id);
  return response.data;
});

interface IOrderLoadedData {
  typeOrderLoaded?: boolean | null;
  productMixDataLoaded?: boolean | null;
  productSetDataLoaded?: boolean | null;
}

type initialStateType = {
  loadedData: IOrderLoadedData;
  /** Lưu ý sự khách biệt.. dữ liệu gốc thì chứa IProductMixOrder mở rộng từ IProductCategory
   * Như vậy sau khi lấy data về (IProductMix) phải qua bước xủ lý lại mang theo (IProductCategory) để phù hợp với (IProductMixOrder)
   * bên trong các phần đang dùng (IProductCategory) phải đảm bảo chạy bình thường
   */
  dataProductMixSearch: Array<IProductMixOrder>; // dùng để lưu các giá trị tìm kiếm danh mục sản phẩm hiện tại
  listProductMixDataPaging: Array<IProductMixOrder>; // dùng để lưu tất cả các giá trị danh mục sản phẩm lấy từ paging về..

  customerSelect?: ICustomer | null;
  typeOrderData: Array<IOptionData>;
  filteCate?: IProductCategory | undefined;
  filterType?: IProductType | undefined;
  filteBrand?: IBrandProduct | undefined;
  productSetData: Array<IProductSet>;
};

const initialState: initialStateType = {
  loadedData: {
    typeOrderLoaded: null,
    productMixDataLoaded: null,
    productSetDataLoaded: null
  },
  dataProductMixSearch: [],
  listProductMixDataPaging: [],
  typeOrderData: [],
  productSetData: [],
  filteCate: undefined,
  filterType: undefined,
  filteBrand: undefined
};

function proccessProductMixData(data: IProductMix[]) {
  // console.log('data product mix', data);

  if (data)
    return (
      data
        // .filter(productF => productF.isActive) // không ẩn đi mà sẽ đặt nó thành disable trong các chỗ chọn
        .map((product: any) => ({
          ...product,
          // Quantity: number,
          requireDetail: true, // luôn luôn yc chi tiết thiết bị với từng dmsp
          inCart: false,
          SumPrice: 0,
          // id: number;
          old: product.productCategory['name'].includes('2G') ? 1 : 0,
          new: product.productCategory['name'].includes('Định vị 4G') ? 1 : 0,
          name: product.maSanPham,
          nameDisplay: product.name,
          giaBanSi: product.giaBanSi || product.productCategory.giaBanSi,
          giaBanLe: product.giaBanLe || product.productCategory.giaBanSi,
          description: product.description
        }))
        ?.sort(
          (a, b) =>
            b.type - a.type ||
            a.index - b.index ||
            a.nameDisplay.localeCompare(b.nameDisplay, 'vi', { sensitivity: 'variant', caseFirst: 'upper' })
        )
      // .sort((a, b) => a.index - b.index)
      // .sort((a, b) => b.type - a.type)
    );
  // đối với này thì thêm sort type để đưa bộ tb lên đầu

  return [];
}

const createOrderSlide = createSlice({
  name: 'createOrder',
  initialState: initialState,
  reducers: {
    resetState: state => {
      // reset
    },
    updateDataTableListOrder: (state, action: PayloadAction<Array<IProductCategory>>) => {
      // state.dataProductMixSearch = action.payload;
    },
    updateListProductSelectFixed: (state, action: PayloadAction<Array<IProductCategory>>) => {
      // state.listProductMixDataPaging = action.payload;
    },
    updateCustomerSelect: (state, action: PayloadAction<ICustomer | null>) => {
      state.customerSelect = action.payload;
    },
    updateFPSearchMix: (
      state,
      action: PayloadAction<{
        data?: IProductCategory | IProductType | IBrandProduct | undefined;
        type?: 'Category' | 'Type' | 'Brand';
        clearAll?: boolean;
      }>
    ) => {
      if (action.payload.clearAll) {
        state.filteCate = undefined;
        state.filterType = undefined;
        state.filteBrand = undefined;
        return;
      }
      switch (action.payload.type) {
        case 'Category': {
          state.filteCate = action.payload.data;
          break;
        }
        case 'Type': {
          state.filterType = action.payload.data;
          break;
        }
        case 'Brand': {
          state.filteBrand = action.payload.data;
          break;
        }
        default:
          break;
      }
    },
    updateProductSet: (state, action: PayloadAction<IProductSet>) => {
      const checkExist = state.productSetData.findIndex(product => product.maSanPham === action.payload.maSanPham);
      if (checkExist > -1) {
        // cập nhật mới nếu đã tồn tại cái cũ
        state.productSetData[checkExist] = { ...action.payload, loadedDetail: true };
        return;
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(getAllTypeOrders.fulfilled, (state, action) => {
      console.log('addCase getAllTypeOrders', action.payload?.data);
      state.typeOrderData =
        action.payload?.data?.map(typeOrder => ({ label: typeOrder.name, value: typeOrder.id })) || [];
      state.loadedData.typeOrderLoaded = true; // đã load loại đơn
    });
    builder.addCase(getInitProductMixData.fulfilled, (state, action) => {
      console.log('addCase getInitProductMixData');
      // có thể check những var khác..
      // {
      // "pageIndex": 1,
      // "totalPages": 1,
      // "items": []
      // "hasPreviousPage": false,
      // "hasNextPage": false
      // }
      state.listProductMixDataPaging = proccessProductMixData(action.payload?.data?.items || []);
      state.loadedData.productMixDataLoaded = true; // đã load list danh mục sản phẩm đầu
    });
    builder.addCase(searchProductMix.fulfilled, (state, action) => {
      state.dataProductMixSearch = proccessProductMixData(action.payload?.data || []);
    });
    builder.addCase(getAllProductSet.fulfilled, (state, action) => {
      state.productSetData =
        action.payload?.data
          ?.sort((a, b) => a.name.localeCompare(b.name, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }))
          .sort((a, b) => a.index - b.index) || [];
      //  sort<IProductSet>(action.payload?.data || []).asc(u => u.name); // thêm sort..
      state.loadedData.productSetDataLoaded = true; // đã load loại đơn
    });
    builder.addCase(getDetailProductSet.fulfilled, (state, action) => {
      action.payload = proccessDetailProductData(action.payload?.data);
      // cập nhật 1 phần tử trong store
      createOrderSlide.caseReducers.updateProductSet(state, action);
    });
  }
});

export const {
  resetState,
  updateDataTableListOrder,
  updateListProductSelectFixed,
  updateCustomerSelect,
  updateFPSearchMix,
  updateProductSet
} = createOrderSlide.actions;

export default createOrderSlide.reducer;
